import React, {useState, useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Box, Button, ButtonBase, CircularProgress, Typography} from '@mui/material';
import * as STYLE_CONSTANTS from '../../../styles/styleConstants';
import CustomViewMenu from './customViewMenu';
// import DatePicker from '../../../pieces/datePicker';
// import CustomFormBlock from '../../../pieces/inputs/formBlock';
// import {inputTypes} from '../../../pieces/inputs/formInput';
// import * as allConstants from '../../../constants/allConstants';
//import DateInput from '../../../pieces/inputs/dateInput';
//import {useForm, useFormContext, FormProvider} from 'react-hook-form';

export const ListViewHeader = (props) => {

  const {extendedFilters, handleClick, gridEnum, menuController, title, viewController} = props;
  const [selectedDate, setSelectedDate] = useState();

  // const formOptions = {
  //   //resolver: yupResolver(validationSchema),
  //   mode: 'onBlur',
  //   reValidateMode: 'onChange',
  //   criteriaMode:'all',
  //   //defaultValues: getDefaultValues({allowedTests: allowedTests, initialData: initialData.current, isDraft: props.draftData})
  // };
  // const formMethods = useForm(formOptions);
  // const control = useFormContext();


  // const inputFormMethods = useMemo(()=> {
  //   return {
  //     control: control?.control,
  //     register: control?.register,
  //     setValueToForm: control?.setValue,
  //     formState: control?.formState
  //   };
  // }, []);

  useEffect( () => {
    setSelectedDate(props.createdFromDate);

  }, [props.createdFromDate])

  const handleExportFilteredData = async()=> {

    viewController.setLoading(true);
    await viewController.exportFilteredData();
    viewController.setLoading(false);
  };


  // const datePickerHandler = (newDate)=>{
  //   if(newDate !== setSelectedDate) {
  //     setSelectedDate(newDate);
  //   }
  // };
  useEffect ( () => {
    if (!selectedDate) return;

    props.createdFromDateChange(selectedDate);

  },[selectedDate]);

  return (
    <>

      <Box display={'flex'} alignItems={'center'} gap={1}>
        {extendedFilters && extendedFilters.controller}
        <ButtonBase disableRipple={false} onClick={handleClick}>
          <Typography variant={'h5'} sx={{marginRight: '16px'}}>{title}</Typography>
          {gridEnum && gridEnum.length !== 1 && menuController.controller}
        </ButtonBase>
        {menuController && menuController.menuItems}
        {/* <FormProvider {...formMethods}>
          <form>
            <DateInput 
                {...inputFormMethods}
                required={true}
                renderLabel={true}
                viewMode={true}
                parent={null} 
                inputType={inputTypes.date}
                labelSecondary={true}
                field_name={'createdFromDate'}
                field={allConstants.JOB_FIELDS.GENERAL.START_DATE}
                defaultValue={selectedDate}
            />
          </form>
        </FormProvider> */}
        {/* <form>
        <Box>
          <Typography variant={'subtitle1'}>Thanh</Typography>
          <CustomFormBlock      
            renderLabel={true}
            viewMode={true}
            parent={null} 
            inputType={inputTypes.date}
            labelSecondary={true}
            field={allConstants.JOB_FIELDS.GENERAL.START_DATE}
            defaultValue={selectedDate}
          />
         </Box>
        </form> */}
          {/* <Box display={'flex'}
              width={'46vw'}
              justifyContent={'space-around'}
              mb={4}>
              {/* <Box mr={2}>
               <Typography variant={'subtitle1'}>{selectedDate?.toLocaleDateString('en-US', {year: 'numeric', month: 'short', day: 'numeric'})}</Typography>
             </Box>; */}
              {/* <Box position={'relative'}>
                <DatePicker handler={datePickerHandler}/>
              </Box>*
            </Box>  */}
        {props.createdFromDateChange && <div style={{ position: 'relative', display: 'inline-block' }}>
          <label
            htmlFor="date-input"
            style={{
              position: 'absolute',
              top: '-4px',
              backgroundColor: 'white',
              fontSize: '0.75rem',
              padding: '0 0.50rem',
              lineHeight: 1,
              color: '#555',
            }}
          >
            Created From
          </label>
          <input
            id="date-input"
            type="date"
            value={selectedDate}
            onClick={() => {
              // Clear value every time user opens calendar
              setSelectedDate(null);
            }}
            onChange={(e) => {
              setSelectedDate(e.target.value);
            }}
            style={{
              border: '1px solid #ccc',
              borderRadius: '4px',
              width: '130px',
              padding: '0 0.50rem',
              margin: 0,
              fontSize: '0.9rem',
              height: '2rem',
              boxSizing: 'border-box',
            }}
          />
         </div>}
        {props.showCustomView && 
           <CustomViewMenu showCustomView={props.showCustomView} userId={viewController?.user.id} newCustomViewId={viewController?.newCustomViewId} 
                          origView={gridEnum[menuController.viewGrid].title} changeCurrentView = {props.changeCurrentView}  />
        }
        <Typography>Export:</Typography>
        {viewController && <>
          <Button sx={{minWidth: 'unset', padding: '4px', color: STYLE_CONSTANTS.COLORS.linkColor}}
            onClick={viewController.exportAll}>Page</Button>
          <Typography>or</Typography>
          <Button sx={{minWidth: 'unset', padding: '4px', color: STYLE_CONSTANTS.COLORS.linkColor}}
            onClick={viewController.exportChecked}>Checked</Button>
          <Typography>or</Typography>
          <Button sx={{minWidth: 'unset', padding: '4px', color: STYLE_CONSTANTS.COLORS.linkColor}}
            onClick={handleExportFilteredData}>All Pages</Button>
           {viewController.isLoading && <Box display='flex' justifyContent='center' alignItems='center'>
                <CircularProgress variant="indeterminate"  color="success" />
                <Typography color="red" variant="h6">
                    Please wait!
                </Typography>                
              </Box>}
        </>}

      </Box>
    </>
  );
};

ListViewHeader.propTypes = {
  extendedFilters: PropTypes.instanceOf(Object),
  handleClick: PropTypes.func,
  //gridEnum: PropTypes.arrayOf(PropTypes.string),
  gridEnum: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  menuController: PropTypes.instanceOf(Object),
  title: PropTypes.string,
  viewController: PropTypes.instanceOf(Object),
};

ListViewHeader.defaultProps = {
  extendedFilters: null,
  handleClick: null,
  gridEnum: null,
  menuController: null,
  title: '',
  viewController: null,
};
